import { Input as HeadlessInput, InputProps } from '@headlessui/react';
import { ChangeEventHandler } from 'react';

interface Props extends InputProps {
  name: string;
  label: string;
  type?: string;
  variant?: keyof typeof classes;
  placeholder?: string;
  value?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  width?: string;
}

const classes = {
  normal:
    'block rounded-md bg-white px-3 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 disabled:bg-gray-100 disabled:text-gray-400',
  text: 'w-74/75 block rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6',
  color:
    'rounded-md px-1 py-1/2 bg-white outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary',
};

export const Input: React.FC<Props> = ({
  name,
  label,
  type = 'text',
  variant = 'normal',
  className = '',
  width = 'w-full',
  disabled,
  ...props
}) => {
  return (
    <div className={`${width || 'w-full max-w-1/2'}`}>
      <label
        htmlFor={name}
        className="block text-sm/6 font-medium text-gray-900"
      >
        {label}
      </label>
      <div className="mt-2">
        <HeadlessInput
          name={name}
          aria-label={label}
          className={`${classes[variant]} ${className}`}
          type={type}
          disabled={disabled}
          {...props}
        />
      </div>
    </div>
  );
};
